import { Link } from 'react-router-dom'
import { Facebook, Youtube, Instagram, MapPin, Phone, Mail } from 'lucide-react'
import { useSettings } from '@/modules/settings-api'

export function Footer() {
  const { data: s } = useSettings()
  const year = new Date().getFullYear()

  return (
    <footer className="mt-16 bg-[#0f172a] text-slate-300">
      <div className="max-w-[1440px] mx-auto px-6 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="text-xl font-bold text-white mb-4">{s.shopName}</div>
          <p className="text-sm leading-relaxed text-slate-400">{s.description}</p>
          <div className="flex items-center gap-3 mt-5">
            {s.facebookUrl && <a href={s.facebookUrl} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full bg-white/10 hover:bg-brand-600 flex items-center justify-center transition"><Facebook className="w-4 h-4" /></a>}
            {s.youtubeUrl && <a href={s.youtubeUrl} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full bg-white/10 hover:bg-brand-600 flex items-center justify-center transition"><Youtube className="w-4 h-4" /></a>}
            {s.instagramUrl && <a href={s.instagramUrl} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full bg-white/10 hover:bg-brand-600 flex items-center justify-center transition"><Instagram className="w-4 h-4" /></a>}
          </div>
        </div>

        <div>
          <div className="text-white font-semibold mb-4">Sản phẩm</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/danh-muc/xe-may-dien" className="hover:text-white">Xe máy điện</Link></li>
            <li><Link to="/danh-muc/xe-dap-dien" className="hover:text-white">Xe đạp điện</Link></li>
            <li><Link to="/danh-muc/phu-kien" className="hover:text-white">Phụ kiện</Link></li>
            <li><Link to="/danh-muc/pin-sac" className="hover:text-white">Pin & Sạc</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-white font-semibold mb-4">Hỗ trợ</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/chinh-sach-bao-hanh" className="hover:text-white">Chính sách bảo hành</Link></li>
            <li><Link to="/chinh-sach-doi-tra" className="hover:text-white">Đổi trả {s.returnPolicyDays} ngày</Link></li>
            <li><Link to="/huong-dan-mua-hang" className="hover:text-white">Hướng dẫn mua hàng</Link></li>
            <li><Link to="/lien-he" className="hover:text-white">Liên hệ</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-white font-semibold mb-4">Liên hệ</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-brand-500" /><span>{s.address || '—'}</span></li>
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-brand-500" /><a href={`tel:${s.hotline.replace(/\s/g, '')}`} className="hover:text-white">{s.hotline}</a></li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-brand-500" /><a href={`mailto:${s.email}`} className="hover:text-white">{s.email}</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-slate-500">
        © {year} {s.shopName}. All rights reserved.
      </div>
    </footer>
  )
}
